export const dates = {
  methods: {
    dateTimestamp: date => {
      const d = new Date(date).getTime()

      return d
    },

    dateFormat: receiveDate => {
      const date = new Date(receiveDate)
      const dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().split('T')[0]

      return dateString
    },

    stripHour: date => date.split(' ').slice(0, 1).join(' ')
  }
}



// WEBPACK FOOTER //
// ./src/mixins/dates.js